<template>
  <Cfg>
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert"/>
        <Forms ref="frmGroup"
          :title="this.$lang.RegionService.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="onClear"
          v-on:Save="onSave">
          <div class="form-group row">
            <div class="col-md-4">
              <label for="cbxArea"><small class="text-danger">*</small> {{$lang.RegionService.LabelArea}}:</label>
              <div class="input-group">
                <b-form-select v-model="form.areaID.value" :options="form.areaID.options" :state="form.areaID.state" class="mb-3" name="cbxArea">
                   <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-8">
              <label for="txtRegionServiceName"><small class="text-danger">*</small> {{$lang.RegionService.LabelName}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtRegionServiceName"
                              :placeholder="$lang.RegionService.PlaceholderEnterName"
                              v-model="form.name.value"
                              :size="form.name.maxlength"
                              :required="form.name.required"
                              :state="form.name.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="cbxCountry"><small class="text-danger">*</small> {{$lang.Common.LabelCoutry}}:</label>
              <div class="input-group">
                <select class="mb-3 form-control custom-select" disabled>
                  <option value="2375E209-7451-4A7A-A9BE-66BD2C392BE1" selected>BRASIL</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-5">
              <label for="cbxState">Estados Disponíveis:</label>
              <div class="input-group">
                <b-form-select multiple v-model="form.stateID.value" :options="form.stateID.options" class="mb-3" :select-size="6" />
              </div>
            </div>
            <div class="col-md-2 text-center" style="padding-top: 65px;">
              <b-button variant="third" @click="onRemoveStates">Remover</b-button>
              <b-button variant="third" @click="onAddStates">Adicionar</b-button>
            </div>
            <div class="col-md-5">
              <label for="cbxState">Relacionados:</label>
              <div class="input-group">
                <b-form-select multiple v-model="form.stateList.value" :options="form.stateList.options" class="mb-3" :select-size="6"/>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-5">
              <label for="cbxCities">Cidades Disponíveis:</label>
              <div class="input-group">
                <b-form-select multiple v-model="form.cityID.value" :options="form.cityID.options" class="mb-3" :select-size="6"/>
              </div>
            </div>
            <div class="col-md-2 text-center" style="padding-top: 65px;">
              <b-button variant="third" @click="onRemoveCities">Remover</b-button>
              <b-button variant="third" @click="onAddCities">Adicionar</b-button>
            </div>
            <div class="col-md-5">
              <label for="cbxCitiesRelation">Relacionadas:</label>
              <div class="input-group">
                <b-form-select multiple v-model="form.cityList.value" :options="form.cityList.options" class="mb-3" :select-size="6"/>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtDescription"> {{$lang.RegionService.LabelDescription}}:</label>
              <b-form-textarea id="txtDescription"
                          name="txtDescription"
                          v-model.trim="form.description.value"
                          :placeholder="$lang.RegionService.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"></b-form-textarea>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>
        </Forms>

        <Tables ref="tableGrid"
            :columns="[$lang.RegionService.DataTable.Name,
                       $lang.RegionService.DataTable.Area,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.area.name" />
            <TableColumn :IsStatus="true"   v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
            <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>

<script>
import RegionService from './regionservice.js'

export default RegionService
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/regionservice/regionservice.vue